
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-tracker",
  "use": "icon-rescls-tracker-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-tracker\"><path fill=\"#aec8e0\" d=\"M6.833 0h2v24h-2zm4 0h2v24h-2zm4 0h2v24h-2z\" /><path fill=\"#3498db\" d=\"M18.833 20h-14a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1\" /><path fill=\"#fff\" d=\"M11.833 7C9.65 7 7.875 8.741 7.875 10.881c0 .846.273 1.649.786 2.321l2.673 3.549a.624.624 0 0 0 .998 0l2.67-3.545a3.8 3.8 0 0 0 .789-2.325C15.792 8.741 14.016 7 11.833 7m0 5.6c-.948 0-1.719-.771-1.719-1.719s.771-1.719 1.719-1.719 1.719.771 1.719 1.719-.771 1.719-1.719 1.719\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-tracker"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-tracker";

        export default Icon;
    